// extracted by mini-css-extract-plugin
module.exports = {"root":"TabBar_root__99l6N","box":"TabBar_box__2Va_H","selected":"TabBar_selected__Ij4LY"};